<template>
    <div class="modal_cont">
        <div class="modal_header">
            {{ t.MainTitle }}
            <a href="#none" @click="closeModal" class="btn_close">{{ t.closeLabel }}</a>
        </div>

        <div class="modal_content">

            <div class="pop_space">
                <p class="intro_desc">{{ t.intro }}</p>

                <div class="pop_guide_wrap">
                    <section class="section">
                        <strong class="title">{{ t.section1.title }}</strong>
                        <p class="desc">{{ t.section1.desc }}</p>
                    </section>

                    <section class="section">
                        <strong class="title">{{ t.section2.title }}</strong>
                        <p class="desc">{{ t.section2.desc }}</p>
                    </section>

                    <section class="section">
                        <strong class="title">{{ t.section3.title }}</strong>
                        <p class="desc">{{ t.section3.desc }}</p>
                    </section>

                    <section class="section">
                        <strong class="title">{{ t.section4.title }}</strong>
                        <p class="desc">{{ t.section4.desc }}</p>
                    </section>

                    <section class="section">
                        <strong class="title">{{ t.section5.title }}</strong>
                        <p class="desc">{{ t.section5.desc }}</p>
                    </section>

                    <section class="section">
                        <strong class="title">{{ t.section6.title }}</strong>
                        <p class="desc">{{ t.section6.desc }}</p>
                    </section>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import modal from "@/assets/js/modal";
//import Buttons from "@/components/Buttons.vue";

export default {
    name: "gsrsu04020301",
    components: {
        // Buttons
    },
    data() {
        return {
            langData: {
                ko: {
                    closeLabel: "닫기",
                    MainTitle: "작성가이드",
                    intro: '명확하게 자세하게 작성해주셔야 사실 확인이 가능합니다.',
                    section1: {
                        title: "1. 누가",
                        desc: '예시) OO기관 경리과 홍길동 과장\n- 관련자가 다수일 경우 모두 적어주십시오.'
                    },
                    section2: {
                        title: "2.언제",
                        desc: '예시) 2012. 6. 1. 15:00경\n- 약 일주일 전, 약 한 달 전, 약 1년 전부터 계속'
                    },
                    section3: {
                        title: "3.어디서",
                        desc: '- 장소를 특정하기 어려운 경우는 주로 일어나는 장소나 업무처리과정을 적어주십시오.'
                    },
                    section4: {
                        title: "4.내용",
                        desc: '신고사항에 관한 모든 상세한 것들을 빠짐없이 적어주십시오. 평가와 조사 및 처리에 매우 큰 도움이 됩니다.\n- 다만 신고자의 신분이 드러날 수 있는 정황은 적지 마십시오.'
                    },
                    section5: {
                        title: "5.아는 사람",
                        desc: '이 문제를 알고 있거나 알 것으로 예상되는 다른 사람을 적어주십시오.'
                    },
                    section6: {
                        title: "6.확인 방법",
                        desc: '이 신고내용을 저희가 확인하기 위해 가장 좋은 방법으로 생각되는 것을 적어 주십시오.\n예)A장부와 B장부 대조, 0월 0일자 CCTV와 전표확인, 00과장과 00주임 상대로 사실 확인'
                    },
                },
                en: {
                    closeLabel: "close",
                    MainTitle: "작성가이드",
                    intro: '명확하게 자세하게 작성해주셔야 사실 확인이 가능합니다.',
                    section1: {
                        title: "1. 누가",
                        desc: '예시) OO기관 경리과 홍길동 과장\n- 관련자가 다수일 경우 모두 적어주십시오.'
                    },
                    section2: {
                        title: "2.언제",
                        desc: '예시) 2012. 6. 1. 15:00경\n- 약 일주일 전, 약 한 달 전, 약 1년 전부터 계속'
                    },
                    section3: {
                        title: "3.어디서",
                        desc: '- 장소를 특정하기 어려운 경우는 주로 일어나는 장소나 업무처리과정을 적어주십시오.'
                    },
                    section4: {
                        title: "4.내용",
                        desc: '신고사항에 관한 모든 상세한 것들을 빠짐없이 적어주십시오. 평가와 조사 및 처리에 매우 큰 도움이 됩니다.\n- 다만 신고자의 신분이 드러날 수 있는 정황은 적지 마십시오.'
                    },
                    section5: {
                        title: "5.아는 사람",
                        desc: '이 문제를 알고 있거나 알 것으로 예상되는 다른 사람을 적어주십시오.'
                    },
                    section6: {
                        title: "6.확인 방법",
                        desc: '이 신고내용을 저희가 확인하기 위해 가장 좋은 방법으로 생각되는 것을 적어 주십시오.\n예)A장부와 B장부 대조, 0월 0일자 CCTV와 전표확인, 00과장과 00주임 상대로 사실 확인'
                    },
                }
            }
        };
    },
    computed: { 
        t() { 
            // 260708 임시: 팝업은 공통 modal.js가 lang을 안 넘겨 항상 ko로 뜨는 문제 →
            // 현재 언어를 헤더 활성버튼에서 직접 읽어 처리 (공통 modal.js 불변). 개발팀이 modal.js에서 lang 전달하면 이 부분 원복 가능.
            const curBtn = document.querySelector(".language button.current");
            const lang = curBtn ? curBtn.textContent.trim().toLowerCase() : (this.lang || "ko");
            const data = this.langData[lang] || this.langData.ko;
            return data || {}; 
        } 
    },
    methods: {
        closeModal(event) { modal.close(event.currentTarget); }
    }
};
</script>

<style scoped>
.pop_space .intro_desc {color:#444; font-size:18px; line-height:26px;white-space:pre-line;}
.pop_guide_wrap {font-size:15px; line-height:25px;}
.pop_guide_wrap .title {display:block;font-size:18px;font-weight:700;padding-bottom:20px}
.pop_guide_wrap .title_b {display:block;font-size:15px;font-weight:normal;margin-bottom:20px;}
.pop_guide_wrap .section {padding:20px 0;}
.pop_guide_wrap .section:last-child {border-bottom:0}
.pop_guide_wrap .section .desc {font-size:15px;line-height:25px;white-space:pre-line;}
.pop_guide_wrap .section .smp_announcement>dl {overflow:hidden;margin-top:10px}
.pop_guide_wrap .section .smp_announcement>dl dt {float:left;background:#0072bc;border-radius:15px;color:#fff;text-align:center;width:42px;font-size:13px;line-height:19px}
.pop_guide_wrap .section .smp_announcement>dl dd {padding-left:50px;margin-bottom:7px;padding-bottom:7px;line-height:19px;font-size:15px}
.pop_guide_wrap .image_wrap {margin:30px 0; text-align: center;}
.pop_guide_wrap .image_wrap img {width:100%}
.pop_guide_wrap .row {padding-left:20px;color: #666666}
.pop_guide_wrap .sub_content_block {margin-bottom:25px;}
.pop_guide_wrap .sub_content_block .title_b {margin-bottom:0;}
.pop_guide_wrap .cancel_criteria {margin-bottom:25px;}
.pop_guide_wrap .section.addendum strong {font-weight:normal}

/* 모달 레이아웃 */
.modal_cont {background-color: #fff;}
.modal_header {display:flex; justify-content:space-between; align-items:center; padding-bottom:40px; font-size:40px; font-weight:700; border-bottom:0;}
.modal_content {max-height:700px; overflow-y:auto; padding-right:10px;}
.btn-wrap {display:flex; justify-content:flex-end;}

/* 반응형 */
@media screen and (max-width: 767px) {
    .modal_header {font-size:18px; padding-bottom:24px;}
    .pop_space .intro_desc {padding-top:80px; background-position:center top;}
}
</style>
